"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurposeType = exports.EmailTemplateType = exports.ConversionStatus = exports.UserNotationsStatus = exports.UserNotationsType = exports.EmailTemplateStatus = exports.DocumentAccessLevel = exports.FileType = exports.AssociatedFileType = exports.AssociatedFileStatus = exports.PageGroupSource = exports.MappingStatus = exports.DocumentVersionChangeType = exports.SyncScope = exports.NotificationScope = exports.FieldDataType = exports.CrmIntegrationType = exports.StandaloneFormUsage = exports.TenantStatus = exports.EmailReportType = exports.NamedFilterType = exports.Frequency = exports.UserRole = exports.TenantFormStatus = exports.TenantFormTargetType = exports.InputEngineType = exports.UserStatus = exports.TenantLogoVariance = exports.AttachedFileEntityType = exports.LangflowStatus = exports.Bulletin = exports.PromptValues = exports.CustomFormRecord = exports.Hub = exports.Meeting = exports.TrainingEvent = exports.IntegrationSettings = exports.IntegrationLog = exports.ContentShare = exports.Folder = exports.CustomDeck = exports.UserNotations = exports.UserDocumentVersionSettings = exports.EmailTemplate = exports.Document = exports.AttachedFile = exports.DocumentVersion = exports.UserSettings = exports.Tenant = exports.User = void 0;
exports.BulletinStatus = exports.RelatedSlidePageType = exports.PromptStatus = exports.PromptType = exports.ZendeskFeature = exports.PermissionEffect = exports.CustomFormRecordEntity = exports.CustomFormRecordRelationshipModel = exports.CustomFormRecordStatus = exports.CustomFieldUsage = exports.DateRestriction = exports.FieldPosition = exports.CustomFieldActionSkip = exports.CustomFieldAction = exports.FormatValidation = exports.ControlType = exports.FieldStatus = exports.AttendeeType = exports.ObjectRecordStatus = exports.MeetingAttendeeStatus = exports.MeetingStatus = exports.MeetingType = exports.MeetingContentType = exports.ContentPresentedStatus = exports.Sentiment = exports.CrmSyncStatus = exports.HubSectionItemStatus = exports.HubSharedFileContentType = exports.TodoStatus = exports.NotationType = exports.HubSectionType = exports.HubSectionStatus = exports.HubType = exports.HubStatus = exports.ForcePropertyUpdate = exports.IntegrationRunStatus = exports.LogLevel = exports.DocumentMappingStatus = exports.DocumentMappingAction = exports.IntegrationType = exports.ConversionWarningCode = exports.ShareType = exports.ShareNotificationScope = exports.FolderStatus = exports.FolderItemStatus = exports.FolderItemType = exports.ShareTargetType = exports.PermissionType = exports.ShareStatus = exports.DocumentStatus = void 0;
exports.ListConfig = exports.CRMDisplaySettings = exports.CRMAddressSettings = exports.CRMAccountSettings = exports.VeevaSetting = exports.CRMChildTableSetting = exports.CRMTableSetting = exports.CRMAccountToObjectFields = exports.CRMAccountToObjectSetting = exports.CRMAdditionalSettings = exports.CRMStandaloneFormParent = exports.CRMStandaloneForm = exports.CRMTableDetailContentPresented = exports.ExternalOidcSsoConfig = exports.CRMIntegration = exports.FeatureFlags = exports.AnalyticsFeed = exports.EntityViewed = exports.EntityViewedEvent = exports.TenantForm = exports.TenantFormTargetParameters = exports.HubConfig = exports.KeyValue = exports.CustomDeckAcknowledgement = exports.EmailReportConfig = exports.FieldLabelAndValueIds = exports.NamedFilter = exports.TenantConfig = exports.TenantCustomStyle = exports.TenantColor = exports.HubAndContentDetails = exports.PresentableContentMetadata = exports.ContentTokenOutput = exports.MostAccessedRecordsOutput = exports.MostAccessedRecordsWrapper = exports.MostAccessedRecords = exports.RecordAccessedCount = exports.LangflowResponse = exports.CsvExportNotification = exports.VeevaAuthenticatedUser = exports.VeevaVaultLoginOutput = exports.VeevaVaultLookupOutput = exports.VeevaVaultPicklistsItemsOutput = exports.VeevaVaultObjectMetadataLayouts = exports.VeevaVaultUpsertObjectsOutput = exports.MantleSummaryDebugSaveResult = exports.MantleSummaryDebugResult = exports.MantleSummaryDebugQuote = exports.MantleSummaryDebugModel = exports.VeevaVaultQueryOutput = void 0;
exports.ContentPresented = exports.HubSharedAssociatedFile = exports.DocumentVersionSettings = exports.Link = exports.ToDo = exports.Coordinate = exports.Notation = exports.SharedFileHubSetting = exports.TextareaHubSettings = exports.HubSection = exports.CRMMeetingRecordInfo = exports.UpsertVersionContentsResult = exports.UpdateDocVerPageMatchesResult = exports.SubmitIntegrationResult = exports.TrainingEventUser = exports.PublisherIntegration = exports.IntegrationLogEntry = exports.IntegrationFieldMapping = exports.IntegrationValueMapping = exports.DocumentMappingResult = exports.DocumentMappingPreview = exports.DocumentMappingSourceVersion = exports.DocumentVersionIntegration = exports.DocumentIntegration = exports.IntegrationClientConfigurationTuple = exports.CustomDeckDependencies = exports.FolderItem = exports.SharePermission = exports.S3Object = exports.Page = exports.PageSetting = exports.AvailableDashboards = exports.Dashboard = exports.ReportItem = exports.ReportGroup = exports.Sheet = exports.CustomDeckPage = exports.CustomDeckGroup = exports.PageSettingOverride = exports.EditMutex = exports.BookmarkedFolder = exports.BookmarkedDoc = exports.LabelValues = exports.LabelValue = exports.AssociatedFile = exports.PageGroup = exports.AiGeneratedDocumentLabel = exports.SemVer = exports.ListSort = exports.FieldListConfig = void 0;
exports.Highlights = exports.TextWithHighlights = exports.RelatedSlidesOutput = exports.RelatedSlidesResultItem = exports.FullTextSearchResultItem = exports.FullTextSearchOutput = exports.QuickFilter = exports.RefreshTokenCRMPayload = exports.AuthInformationPayload = exports.UserInfoPayload = exports.ZendeskTokenPayload = exports.GetSharedFoldersOutput = exports.FolderPermission = exports.GetDependenciesOutput = exports.AccessTokenData = exports.ObjectRecordValue = exports.ObjectRecord = exports.CustomValues = exports.FieldValue = exports.DocumentPermission = exports.DocumentFieldValueSettings = exports.CustomFieldValueDefinition = exports.CustomFormRecordCRMFields = exports.DocumentFieldSettings = exports.CommonFieldSettings = exports.ObjectRestriction = exports.ObjectSetting = exports.CustomFieldDefinition = exports.Attendee = exports.PagePresentedEvent = exports.PresentedMeta = void 0;
// @ts-check
const datastore_1 = require("@aws-amplify/datastore");
const schema_1 = require("./schema");
const LangflowStatus = {
    "SUCCESS": "SUCCESS",
    "ERROR": "ERROR",
    "INFO": "INFO"
};
exports.LangflowStatus = LangflowStatus;
const AttachedFileEntityType = {
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "EMAIL_TEMPLATE": "EMAIL_TEMPLATE"
};
exports.AttachedFileEntityType = AttachedFileEntityType;
const TenantLogoVariance = {
    "PRIMARY": "PRIMARY",
    "HUB": "HUB"
};
exports.TenantLogoVariance = TenantLogoVariance;
const UserStatus = {
    "ACTIVE": "ACTIVE",
    "DEACTIVATED": "DEACTIVATED"
};
exports.UserStatus = UserStatus;
const InputEngineType = {
    "MULTICATEGORICAL": "MULTICATEGORICAL",
    "SINGLECATEGORICAL": "SINGLECATEGORICAL"
};
exports.InputEngineType = InputEngineType;
const TenantFormTargetType = {
    "API": "API"
};
exports.TenantFormTargetType = TenantFormTargetType;
const TenantFormStatus = {
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE"
};
exports.TenantFormStatus = TenantFormStatus;
const UserRole = {
    "ALUCIO_ADMIN": "AlucioAdmin",
    "TENANT_ADMIN": "TenantAdmin",
    "TENANT_PUBLISHER": "TenantPublisher",
    "TENANT_VIEWER": "TenantViewer",
    "TENANT_VIEW_ONLY": "TenantViewOnly",
    "TEAM_REPORT_VIEWER": "TeamReportViewer",
    "LEAD_VIEWER": "LeadViewer"
};
exports.UserRole = UserRole;
const Frequency = {
    "DAILY": "DAILY",
    "WEEKLY": "WEEKLY",
    "MONTHLY": "MONTHLY"
};
exports.Frequency = Frequency;
const NamedFilterType = {
    "SEARCH_QA_HARD_FILTER": "SEARCH_QA_HARD_FILTER",
    "SEARCH_QA_PRIORITY_DOCS": "SEARCH_QA_PRIORITY_DOCS",
    "SEARCH_QA_MESSAGING_DOCS": "SEARCH_QA_MESSAGING_DOCS"
};
exports.NamedFilterType = NamedFilterType;
const EmailReportType = {
    "DOCUMENT_UPDATE_NOTIFICATION": "DOCUMENT_UPDATE_NOTIFICATION",
    "ALL_DOCUMENTS_VIEWED": "ALL_DOCUMENTS_VIEWED",
    "DOCUMENT_EXPIRATION_ALERTS": "DOCUMENT_EXPIRATION_ALERTS"
};
exports.EmailReportType = EmailReportType;
const TenantStatus = {
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE",
    "PURGED": "PURGED"
};
exports.TenantStatus = TenantStatus;
const StandaloneFormUsage = {
    "STANDALONE": "STANDALONE",
    "MEETINGS": "MEETINGS"
};
exports.StandaloneFormUsage = StandaloneFormUsage;
const CrmIntegrationType = {
    "SALESFORCE": "SALESFORCE",
    "VEEVA": "VEEVA",
    "VEEVA_VAULT": "VEEVA_VAULT"
};
exports.CrmIntegrationType = CrmIntegrationType;
const FieldDataType = {
    "CATEGORICAL": "CATEGORICAL",
    "MULTICATEGORICAL": "MULTICATEGORICAL",
    "STRING": "STRING",
    "DATE": "DATE",
    "USER_LIST": "USER_LIST",
    "OBJECT": "OBJECT",
    "NUMBER": "NUMBER"
};
exports.FieldDataType = FieldDataType;
const NotificationScope = {
    "NONE": "NONE",
    "EMAIL": "EMAIL",
    "EMAIL_IMMEDIATE": "EMAIL_IMMEDIATE",
    "EMAIL_IMMEDIATE_WITHDRAWN": "EMAIL_IMMEDIATE_WITHDRAWN"
};
exports.NotificationScope = NotificationScope;
const SyncScope = {
    "PUBLISHER": "PUBLISHER",
    "VIEWER": "VIEWER",
    "NONE": "NONE"
};
exports.SyncScope = SyncScope;
const DocumentVersionChangeType = {
    "MAJOR": "MAJOR",
    "MINOR": "MINOR"
};
exports.DocumentVersionChangeType = DocumentVersionChangeType;
const MappingStatus = {
    "HAS_MAPPINGS": "HAS_MAPPINGS",
    "NO_MAPPINGS": "NO_MAPPINGS"
};
exports.MappingStatus = MappingStatus;
const PageGroupSource = {
    "USER": "USER",
    "DOCUMENT": "DOCUMENT"
};
exports.PageGroupSource = PageGroupSource;
const AssociatedFileStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.AssociatedFileStatus = AssociatedFileStatus;
const AssociatedFileType = {
    "DOCUMENT": "DOCUMENT",
    "ATTACHED_FILE": "ATTACHED_FILE"
};
exports.AssociatedFileType = AssociatedFileType;
const FileType = {
    "JPG": "JPG",
    "JPEG": "JPEG",
    "XLS": "XLS",
    "XLSX": "XLSX",
    "XLSM": "XLSM",
    "DOC": "DOC",
    "DOCX": "DOCX",
    "PDF": "PDF",
    "PPTX": "PPTX",
    "PNG": "PNG",
    "MP4": "MP4",
    "WEB": "WEB",
    "HTML": "HTML",
    "ZIP": "ZIP"
};
exports.FileType = FileType;
const DocumentAccessLevel = {
    "TENANT": "TENANT",
    "USER": "USER"
};
exports.DocumentAccessLevel = DocumentAccessLevel;
const EmailTemplateStatus = {
    "DRAFT": "DRAFT",
    "ACTIVE": "ACTIVE",
    "DEACTIVATED": "DEACTIVATED",
    "REMOVED": "REMOVED"
};
exports.EmailTemplateStatus = EmailTemplateStatus;
const UserNotationsType = {
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "CUSTOM_DECK": "CUSTOM_DECK"
};
exports.UserNotationsType = UserNotationsType;
const UserNotationsStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.UserNotationsStatus = UserNotationsStatus;
const ConversionStatus = {
    "PENDING": "PENDING",
    "PROCESSING": "PROCESSING",
    "PROCESSED": "PROCESSED",
    "ERROR": "ERROR"
};
exports.ConversionStatus = ConversionStatus;
const EmailTemplateType = {
    "HTML": "HTML",
    "PLAIN_TEXT": "PLAIN_TEXT"
};
exports.EmailTemplateType = EmailTemplateType;
const PurposeType = {
    "INTERNAL_USE_ONLY": "INTERNAL_USE_ONLY",
    "EXTERNAL_PROACTIVE": "EXTERNAL_PROACTIVE",
    "EXTERNAL_REACTIVE": "EXTERNAL_REACTIVE",
    "NOT_DEFINED": "NOT_DEFINED"
};
exports.PurposeType = PurposeType;
const DocumentStatus = {
    "ARCHIVED": "ARCHIVED",
    "REVOKED": "REVOKED",
    "NOT_PUBLISHED": "NOT_PUBLISHED",
    "PUBLISHED": "PUBLISHED",
    "DELETED": "DELETED",
    "ARCHIVED_WITH_VERSIONS": "ARCHIVED_WITH_VERSIONS",
    "REVOKED_WITH_VERSIONS": "REVOKED_WITH_VERSIONS",
    "DELETED_WITH_VERSIONS": "DELETED_WITH_VERSIONS"
};
exports.DocumentStatus = DocumentStatus;
const ShareStatus = {
    "IS_SHARED": "IS_SHARED",
    "NOT_SHARED": "NOT_SHARED"
};
exports.ShareStatus = ShareStatus;
const PermissionType = {
    "VIEW": "VIEW",
    "EDIT": "EDIT"
};
exports.PermissionType = PermissionType;
const ShareTargetType = {
    "USER": "USER",
    "FILTER": "FILTER",
    "ALL": "ALL"
};
exports.ShareTargetType = ShareTargetType;
const FolderItemType = {
    "FOLDER": "FOLDER",
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "CUSTOM_DECK": "CUSTOM_DECK"
};
exports.FolderItemType = FolderItemType;
const FolderItemStatus = {
    "ACTIVE": "ACTIVE",
    "REMOVED": "REMOVED"
};
exports.FolderItemStatus = FolderItemStatus;
const FolderStatus = {
    "ACTIVE": "ACTIVE",
    "ARCHIVED": "ARCHIVED",
    "REMOVED": "REMOVED"
};
exports.FolderStatus = FolderStatus;
const ShareNotificationScope = {
    "EMAIL": "EMAIL",
    "NONE": "NONE"
};
exports.ShareNotificationScope = ShareNotificationScope;
const ShareType = {
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "RECORDING": "RECORDING",
    "ATTACHED_FILE": "ATTACHED_FILE",
    "HUB": "HUB",
    "CUSTOM_DECK": "CUSTOM_DECK"
};
exports.ShareType = ShareType;
const ConversionWarningCode = {
    "PASSWORD_PROTECTED": "PASSWORD_PROTECTED"
};
exports.ConversionWarningCode = ConversionWarningCode;
const IntegrationType = {
    "VEEVA": "VEEVA",
    "BEACON": "BEACON",
    "EXPORT_TO_S3": "EXPORT_TO_S3",
    "NONE": "NONE"
};
exports.IntegrationType = IntegrationType;
const DocumentMappingAction = {
    "LINK": "LINK",
    "UNLINK": "UNLINK"
};
exports.DocumentMappingAction = DocumentMappingAction;
const DocumentMappingStatus = {
    "READY": "READY",
    "SUCCEEDED": "SUCCEEDED",
    "PARTIAL": "PARTIAL",
    "NO_CHANGE": "NO_CHANGE"
};
exports.DocumentMappingStatus = DocumentMappingStatus;
const LogLevel = {
    "WARNING": "WARNING",
    "ERROR": "ERROR",
    "SUCCESS": "SUCCESS",
    "INFO": "INFO"
};
exports.LogLevel = LogLevel;
const IntegrationRunStatus = {
    "RUNNING": "RUNNING",
    "COMPLETED": "COMPLETED",
    "WARNING": "WARNING",
    "ERROR": "ERROR"
};
exports.IntegrationRunStatus = IntegrationRunStatus;
const ForcePropertyUpdate = {
    "OVERRIDE": "OVERRIDE",
    "POPULATE": "POPULATE"
};
exports.ForcePropertyUpdate = ForcePropertyUpdate;
const HubStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.HubStatus = HubStatus;
const HubType = {
    "STANDALONE": "STANDALONE",
    "TEMPLATE_INSTANCE": "TEMPLATE_INSTANCE",
    "TEMPLATE": "TEMPLATE"
};
exports.HubType = HubType;
const HubSectionStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.HubSectionStatus = HubSectionStatus;
const HubSectionType = {
    "TEXTAREA": "TEXTAREA",
    "SHARED_FILES": "SHARED_FILES",
    "TODO_LIST": "TODO_LIST",
    "LINKS": "LINKS"
};
exports.HubSectionType = HubSectionType;
const NotationType = {
    "CALLOUT": "CALLOUT",
    "PAGE_NOTE": "PAGE_NOTE",
    "TEXT_INSERTION": "TEXT_INSERTION"
};
exports.NotationType = NotationType;
const TodoStatus = {
    "ACTIVE": "ACTIVE",
    "COMPLETED": "COMPLETED",
    "DELETED": "DELETED"
};
exports.TodoStatus = TodoStatus;
const HubSharedFileContentType = {
    "DOCUMENT_VERSION": "DOCUMENT_VERSION"
};
exports.HubSharedFileContentType = HubSharedFileContentType;
const HubSectionItemStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.HubSectionItemStatus = HubSectionItemStatus;
const CrmSyncStatus = {
    "SYNCED": "SYNCED",
    "NOT_SYNCED": "NOT_SYNCED",
    "DELETED": "DELETED"
};
exports.CrmSyncStatus = CrmSyncStatus;
const Sentiment = {
    "POSITIVE": "POSITIVE",
    "NEGATIVE": "NEGATIVE"
};
exports.Sentiment = Sentiment;
const ContentPresentedStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.ContentPresentedStatus = ContentPresentedStatus;
const MeetingContentType = {
    "CUSTOM_DECK": "CUSTOM_DECK",
    "DOCUMENT_VERSION": "DOCUMENT_VERSION",
    "DOCUMENT_VERSION_GROUP": "DOCUMENT_VERSION_GROUP"
};
exports.MeetingContentType = MeetingContentType;
const MeetingType = {
    "IN_PERSON": "IN_PERSON",
    "VIRTUAL": "VIRTUAL",
    "MANUAL": "MANUAL"
};
exports.MeetingType = MeetingType;
const MeetingStatus = {
    "IN_PROGRESS": "IN_PROGRESS",
    "ENDED_EXIT": "ENDED_EXIT",
    "ENDED_TIMEOUT": "ENDED_TIMEOUT",
    "DELETED": "DELETED",
    "LOCKED": "LOCKED",
    "PLANNED": "PLANNED"
};
exports.MeetingStatus = MeetingStatus;
const MeetingAttendeeStatus = {
    "ACTIVE": "ACTIVE",
    "REMOVED": "REMOVED"
};
exports.MeetingAttendeeStatus = MeetingAttendeeStatus;
const ObjectRecordStatus = {
    "ACTIVE": "ACTIVE",
    "REMOVED": "REMOVED"
};
exports.ObjectRecordStatus = ObjectRecordStatus;
const AttendeeType = {
    "PRIMARY": "PRIMARY",
    "SECONDARY": "SECONDARY",
    "CRM_USER": "CRM_USER"
};
exports.AttendeeType = AttendeeType;
const FieldStatus = {
    "DISABLED": "DISABLED",
    "ENABLED": "ENABLED"
};
exports.FieldStatus = FieldStatus;
const ControlType = {
    "SELECT": "SELECT",
    "RADIOLIST": "RADIOLIST",
    "CHECKBOX": "CHECKBOX",
    "CHECKBOXLIST": "CHECKBOXLIST",
    "CRMACCOUNTSEARCHER": "CRMACCOUNTSEARCHER",
    "CRMATTENDEELIST": "CRMATTENDEELIST",
    "INPUT": "INPUT",
    "TEXTAREA": "TEXTAREA",
    "DATEPICKER": "DATEPICKER",
    "USERLIST": "USERLIST",
    "CUSTOM": "CUSTOM",
    "OBJECT": "OBJECT",
    "LABEL": "LABEL",
    "INFO_MESSAGE": "INFO_MESSAGE",
    "DATETIMEPICKER": "DATETIMEPICKER",
    "INPUT_CSV": "INPUT_CSV"
};
exports.ControlType = ControlType;
const FormatValidation = {
    "EMAIL": "EMAIL",
    "EMAIL_CSV": "EMAIL_CSV"
};
exports.FormatValidation = FormatValidation;
const CustomFieldAction = {
    "ARCHIVE": "ARCHIVE",
    "REVOKE": "REVOKE"
};
exports.CustomFieldAction = CustomFieldAction;
const CustomFieldActionSkip = {
    "INTEGRATION": "INTEGRATION"
};
exports.CustomFieldActionSkip = CustomFieldActionSkip;
const FieldPosition = {
    "LEFT": "LEFT",
    "RIGHT": "RIGHT"
};
exports.FieldPosition = FieldPosition;
const DateRestriction = {
    "ONLY_FUTURE": "ONLY_FUTURE",
    "ONLY_PAST": "ONLY_PAST"
};
exports.DateRestriction = DateRestriction;
const CustomFieldUsage = {
    "USER_FILTER": "USER_FILTER",
    "MEETING": "MEETING",
    "DOCUMENT": "DOCUMENT",
    "EMAIL_TEMPLATE_FILTER": "EMAIL_TEMPLATE_FILTER",
    "CONTENT_SHARE": "CONTENT_SHARE",
    "HUB": "HUB",
    "TENANT_FORM": "TENANT_FORM"
};
exports.CustomFieldUsage = CustomFieldUsage;
const CustomFormRecordStatus = {
    "ACTIVE": "ACTIVE",
    "LOCKED": "LOCKED",
    "DELETED": "DELETED"
};
exports.CustomFormRecordStatus = CustomFormRecordStatus;
const CustomFormRecordRelationshipModel = {
    "MEETING": "MEETING"
};
exports.CustomFormRecordRelationshipModel = CustomFormRecordRelationshipModel;
const CustomFormRecordEntity = {
    "BEACON_TENANT_FORM": "BEACON_TENANT_FORM",
    "CRM_OBJECT": "CRM_OBJECT",
    "SURVEY_TARGET": "SURVEY_TARGET"
};
exports.CustomFormRecordEntity = CustomFormRecordEntity;
const PermissionEffect = {
    "ALLOW": "ALLOW",
    "BLOCK": "BLOCK"
};
exports.PermissionEffect = PermissionEffect;
const ZendeskFeature = {
    "CHAT": "CHAT",
    "SSO": "SSO"
};
exports.ZendeskFeature = ZendeskFeature;
const PromptType = {
    "DECK_COMPLIANCE_RULE": "DECK_COMPLIANCE_RULE",
    "TENANT_BACKGROUND": "TENANT_BACKGROUND",
    "AI_SUMMARY_DOC_TYPE": "AI_SUMMARY_DOC_TYPE",
    "AI_SUMMARY_INSTRUCTIONS": "AI_SUMMARY_INSTRUCTIONS",
    "AI_SEARCH_ABBREVIATIONS": "AI_SEARCH_ABBREVIATIONS"
};
exports.PromptType = PromptType;
const PromptStatus = {
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.PromptStatus = PromptStatus;
const RelatedSlidePageType = {
    "COVER": "COVER",
    "AGENDA": "AGENDA",
    "CONTENT": "CONTENT",
    "CLINICAL_DATA": "CLINICAL_DATA",
    "SAFETY_INFORMATION": "SAFETY_INFORMATION",
    "BIBLIOGRAPHY": "BIBLIOGRAPHY",
    "APPENDIX": "APPENDIX",
    "OTHER": "OTHER"
};
exports.RelatedSlidePageType = RelatedSlidePageType;
const BulletinStatus = {
    "DRAFT": "DRAFT",
    "ACTIVE": "ACTIVE",
    "DELETED": "DELETED"
};
exports.BulletinStatus = BulletinStatus;
const { User, Tenant, UserSettings, DocumentVersion, AttachedFile, Document, EmailTemplate, UserDocumentVersionSettings, UserNotations, CustomDeck, Folder, ContentShare, IntegrationLog, IntegrationSettings, TrainingEvent, Meeting, Hub, CustomFormRecord, PromptValues, Bulletin, VeevaVaultQueryOutput, MantleSummaryDebugModel, MantleSummaryDebugQuote, MantleSummaryDebugResult, MantleSummaryDebugSaveResult, VeevaVaultUpsertObjectsOutput, VeevaVaultObjectMetadataLayouts, VeevaVaultPicklistsItemsOutput, VeevaVaultLookupOutput, VeevaVaultLoginOutput, VeevaAuthenticatedUser, CsvExportNotification, LangflowResponse, RecordAccessedCount, MostAccessedRecords, MostAccessedRecordsWrapper, MostAccessedRecordsOutput, ContentTokenOutput, PresentableContentMetadata, HubAndContentDetails, TenantColor, TenantCustomStyle, TenantConfig, NamedFilter, FieldLabelAndValueIds, EmailReportConfig, CustomDeckAcknowledgement, KeyValue, HubConfig, TenantFormTargetParameters, TenantForm, EntityViewedEvent, EntityViewed, AnalyticsFeed, FeatureFlags, CRMIntegration, ExternalOidcSsoConfig, CRMTableDetailContentPresented, CRMStandaloneForm, CRMStandaloneFormParent, CRMAdditionalSettings, CRMAccountToObjectSetting, CRMAccountToObjectFields, CRMTableSetting, CRMChildTableSetting, VeevaSetting, CRMAccountSettings, CRMAddressSettings, CRMDisplaySettings, ListConfig, FieldListConfig, ListSort, SemVer, AiGeneratedDocumentLabel, PageGroup, AssociatedFile, LabelValue, LabelValues, BookmarkedDoc, BookmarkedFolder, EditMutex, PageSettingOverride, CustomDeckGroup, CustomDeckPage, Sheet, ReportGroup, ReportItem, Dashboard, AvailableDashboards, PageSetting, Page, S3Object, SharePermission, FolderItem, CustomDeckDependencies, IntegrationClientConfigurationTuple, DocumentIntegration, DocumentVersionIntegration, DocumentMappingSourceVersion, DocumentMappingPreview, DocumentMappingResult, IntegrationValueMapping, IntegrationFieldMapping, IntegrationLogEntry, PublisherIntegration, TrainingEventUser, SubmitIntegrationResult, UpdateDocVerPageMatchesResult, UpsertVersionContentsResult, CRMMeetingRecordInfo, HubSection, TextareaHubSettings, SharedFileHubSetting, Notation, Coordinate, ToDo, Link, DocumentVersionSettings, HubSharedAssociatedFile, ContentPresented, PresentedMeta, PagePresentedEvent, Attendee, CustomFieldDefinition, ObjectSetting, ObjectRestriction, CommonFieldSettings, DocumentFieldSettings, CustomFormRecordCRMFields, CustomFieldValueDefinition, DocumentFieldValueSettings, DocumentPermission, FieldValue, CustomValues, ObjectRecord, ObjectRecordValue, AccessTokenData, GetDependenciesOutput, FolderPermission, GetSharedFoldersOutput, ZendeskTokenPayload, UserInfoPayload, AuthInformationPayload, RefreshTokenCRMPayload, QuickFilter, FullTextSearchOutput, FullTextSearchResultItem, RelatedSlidesResultItem, RelatedSlidesOutput, TextWithHighlights, Highlights } = (0, datastore_1.initSchema)(schema_1.schema);
exports.User = User;
exports.Tenant = Tenant;
exports.UserSettings = UserSettings;
exports.DocumentVersion = DocumentVersion;
exports.AttachedFile = AttachedFile;
exports.Document = Document;
exports.EmailTemplate = EmailTemplate;
exports.UserDocumentVersionSettings = UserDocumentVersionSettings;
exports.UserNotations = UserNotations;
exports.CustomDeck = CustomDeck;
exports.Folder = Folder;
exports.ContentShare = ContentShare;
exports.IntegrationLog = IntegrationLog;
exports.IntegrationSettings = IntegrationSettings;
exports.TrainingEvent = TrainingEvent;
exports.Meeting = Meeting;
exports.Hub = Hub;
exports.CustomFormRecord = CustomFormRecord;
exports.PromptValues = PromptValues;
exports.Bulletin = Bulletin;
exports.VeevaVaultQueryOutput = VeevaVaultQueryOutput;
exports.MantleSummaryDebugModel = MantleSummaryDebugModel;
exports.MantleSummaryDebugQuote = MantleSummaryDebugQuote;
exports.MantleSummaryDebugResult = MantleSummaryDebugResult;
exports.MantleSummaryDebugSaveResult = MantleSummaryDebugSaveResult;
exports.VeevaVaultUpsertObjectsOutput = VeevaVaultUpsertObjectsOutput;
exports.VeevaVaultObjectMetadataLayouts = VeevaVaultObjectMetadataLayouts;
exports.VeevaVaultPicklistsItemsOutput = VeevaVaultPicklistsItemsOutput;
exports.VeevaVaultLookupOutput = VeevaVaultLookupOutput;
exports.VeevaVaultLoginOutput = VeevaVaultLoginOutput;
exports.VeevaAuthenticatedUser = VeevaAuthenticatedUser;
exports.CsvExportNotification = CsvExportNotification;
exports.LangflowResponse = LangflowResponse;
exports.RecordAccessedCount = RecordAccessedCount;
exports.MostAccessedRecords = MostAccessedRecords;
exports.MostAccessedRecordsWrapper = MostAccessedRecordsWrapper;
exports.MostAccessedRecordsOutput = MostAccessedRecordsOutput;
exports.ContentTokenOutput = ContentTokenOutput;
exports.PresentableContentMetadata = PresentableContentMetadata;
exports.HubAndContentDetails = HubAndContentDetails;
exports.TenantColor = TenantColor;
exports.TenantCustomStyle = TenantCustomStyle;
exports.TenantConfig = TenantConfig;
exports.NamedFilter = NamedFilter;
exports.FieldLabelAndValueIds = FieldLabelAndValueIds;
exports.EmailReportConfig = EmailReportConfig;
exports.CustomDeckAcknowledgement = CustomDeckAcknowledgement;
exports.KeyValue = KeyValue;
exports.HubConfig = HubConfig;
exports.TenantFormTargetParameters = TenantFormTargetParameters;
exports.TenantForm = TenantForm;
exports.EntityViewedEvent = EntityViewedEvent;
exports.EntityViewed = EntityViewed;
exports.AnalyticsFeed = AnalyticsFeed;
exports.FeatureFlags = FeatureFlags;
exports.CRMIntegration = CRMIntegration;
exports.ExternalOidcSsoConfig = ExternalOidcSsoConfig;
exports.CRMTableDetailContentPresented = CRMTableDetailContentPresented;
exports.CRMStandaloneForm = CRMStandaloneForm;
exports.CRMStandaloneFormParent = CRMStandaloneFormParent;
exports.CRMAdditionalSettings = CRMAdditionalSettings;
exports.CRMAccountToObjectSetting = CRMAccountToObjectSetting;
exports.CRMAccountToObjectFields = CRMAccountToObjectFields;
exports.CRMTableSetting = CRMTableSetting;
exports.CRMChildTableSetting = CRMChildTableSetting;
exports.VeevaSetting = VeevaSetting;
exports.CRMAccountSettings = CRMAccountSettings;
exports.CRMAddressSettings = CRMAddressSettings;
exports.CRMDisplaySettings = CRMDisplaySettings;
exports.ListConfig = ListConfig;
exports.FieldListConfig = FieldListConfig;
exports.ListSort = ListSort;
exports.SemVer = SemVer;
exports.AiGeneratedDocumentLabel = AiGeneratedDocumentLabel;
exports.PageGroup = PageGroup;
exports.AssociatedFile = AssociatedFile;
exports.LabelValue = LabelValue;
exports.LabelValues = LabelValues;
exports.BookmarkedDoc = BookmarkedDoc;
exports.BookmarkedFolder = BookmarkedFolder;
exports.EditMutex = EditMutex;
exports.PageSettingOverride = PageSettingOverride;
exports.CustomDeckGroup = CustomDeckGroup;
exports.CustomDeckPage = CustomDeckPage;
exports.Sheet = Sheet;
exports.ReportGroup = ReportGroup;
exports.ReportItem = ReportItem;
exports.Dashboard = Dashboard;
exports.AvailableDashboards = AvailableDashboards;
exports.PageSetting = PageSetting;
exports.Page = Page;
exports.S3Object = S3Object;
exports.SharePermission = SharePermission;
exports.FolderItem = FolderItem;
exports.CustomDeckDependencies = CustomDeckDependencies;
exports.IntegrationClientConfigurationTuple = IntegrationClientConfigurationTuple;
exports.DocumentIntegration = DocumentIntegration;
exports.DocumentVersionIntegration = DocumentVersionIntegration;
exports.DocumentMappingSourceVersion = DocumentMappingSourceVersion;
exports.DocumentMappingPreview = DocumentMappingPreview;
exports.DocumentMappingResult = DocumentMappingResult;
exports.IntegrationValueMapping = IntegrationValueMapping;
exports.IntegrationFieldMapping = IntegrationFieldMapping;
exports.IntegrationLogEntry = IntegrationLogEntry;
exports.PublisherIntegration = PublisherIntegration;
exports.TrainingEventUser = TrainingEventUser;
exports.SubmitIntegrationResult = SubmitIntegrationResult;
exports.UpdateDocVerPageMatchesResult = UpdateDocVerPageMatchesResult;
exports.UpsertVersionContentsResult = UpsertVersionContentsResult;
exports.CRMMeetingRecordInfo = CRMMeetingRecordInfo;
exports.HubSection = HubSection;
exports.TextareaHubSettings = TextareaHubSettings;
exports.SharedFileHubSetting = SharedFileHubSetting;
exports.Notation = Notation;
exports.Coordinate = Coordinate;
exports.ToDo = ToDo;
exports.Link = Link;
exports.DocumentVersionSettings = DocumentVersionSettings;
exports.HubSharedAssociatedFile = HubSharedAssociatedFile;
exports.ContentPresented = ContentPresented;
exports.PresentedMeta = PresentedMeta;
exports.PagePresentedEvent = PagePresentedEvent;
exports.Attendee = Attendee;
exports.CustomFieldDefinition = CustomFieldDefinition;
exports.ObjectSetting = ObjectSetting;
exports.ObjectRestriction = ObjectRestriction;
exports.CommonFieldSettings = CommonFieldSettings;
exports.DocumentFieldSettings = DocumentFieldSettings;
exports.CustomFormRecordCRMFields = CustomFormRecordCRMFields;
exports.CustomFieldValueDefinition = CustomFieldValueDefinition;
exports.DocumentFieldValueSettings = DocumentFieldValueSettings;
exports.DocumentPermission = DocumentPermission;
exports.FieldValue = FieldValue;
exports.CustomValues = CustomValues;
exports.ObjectRecord = ObjectRecord;
exports.ObjectRecordValue = ObjectRecordValue;
exports.AccessTokenData = AccessTokenData;
exports.GetDependenciesOutput = GetDependenciesOutput;
exports.FolderPermission = FolderPermission;
exports.GetSharedFoldersOutput = GetSharedFoldersOutput;
exports.ZendeskTokenPayload = ZendeskTokenPayload;
exports.UserInfoPayload = UserInfoPayload;
exports.AuthInformationPayload = AuthInformationPayload;
exports.RefreshTokenCRMPayload = RefreshTokenCRMPayload;
exports.QuickFilter = QuickFilter;
exports.FullTextSearchOutput = FullTextSearchOutput;
exports.FullTextSearchResultItem = FullTextSearchResultItem;
exports.RelatedSlidesResultItem = RelatedSlidesResultItem;
exports.RelatedSlidesOutput = RelatedSlidesOutput;
exports.TextWithHighlights = TextWithHighlights;
exports.Highlights = Highlights;
//# sourceMappingURL=index.js.map